import { render, staticRenderFns } from "./BottomTabContainer.vue?vue&type=template&id=755904c2&scoped=true"
import script from "./BottomTabContainer.vue?vue&type=script&lang=js"
export * from "./BottomTabContainer.vue?vue&type=script&lang=js"
import style0 from "./BottomTabContainer.vue?vue&type=style&index=0&id=755904c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755904c2",
  null
  
)

export default component.exports